import { render, staticRenderFns } from "./vFormElementMixin.js.vue?vue&type=template&id=19809905&"
import script from "./vFormElementMixin.js.vue?vue&type=script&lang=js&"
export * from "./vFormElementMixin.js.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports